import React from 'react';
import DataTableManualCustom from './DataTableManualCustom';

const DataTableWrapper = ({ 
  id,
  columns, 
  data, 
  pages, 
  loadDataAction, 
  loadDataParams, 
  noDataText, 
  defaultPageSize = 20, 
  filterable = false,
  handler,
}) => {

  return (
    <DataTableManualCustom
      id={id}
      columns={columns}
      data={data}
      defaultPageSize={defaultPageSize}
      noDataText={noDataText}
      loadDataAction={loadDataAction}
      loadDataParams={loadDataParams}
      filterable={filterable}
      pages={pages}
      handler={handler}
      getTdProps={() => ({
        className: 'hide-scrollbar',
      })}
    />
  )
}

export default React.memo(DataTableWrapper);